import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";

import { ICameraLayerCamera } from "../models/Layers";
import { useRootStore } from "../models/Root";
import { Div } from "trunx";

const CameraInfoPanel = ({ camera }: { camera: ICameraLayerCamera }) => {
  const {
    layers: { clearCamera: close },
  } = useRootStore();
  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={camera.name} close={close} />
      </Div>
      <LeafletPanelBody>
        <img
          src={camera.url}
          alt={camera.name}
          style={{ width: "100%", padding: "1rem" }}
        />
      </LeafletPanelBody>
    </Div>
  );
};

export default CameraInfoPanel;
